<template>
  <div class="home">
    <el-carousel :interval="4000" arrow="always" height="300px" class="carouse-hp" style="margin-top: -1px">
      <el-carousel-item v-for="(item, index) in carousel" :key="index">
        <img style="width: 100%; height: 100%" :src="webUrl + item.img_path" @click="picClick(item)" />
      </el-carousel-item>
    </el-carousel>
    <Search ref="search"></Search>
    <div class="inner home-inner" :style="{ width: minWidth + 'px' }">
      <!-- <Cascader ref="cascader"></Cascader> -->
      <HotJob ref="hotJob" :minWidth="minWidth"></HotJob>
      <HotCompany ref="hotCompany" :minWidth="minWidth"></HotCompany>
      <!-- <HotCity :minWidth="minWidth"></HotCity> -->
    </div>
    <!-- 文字通知公告 -->
    <notice ref="noticeRef"></notice>
    <Loading v-if="$store.state.showLoading"></Loading>
  </div>
</template>

<script>
import HotJob from './components/HotJob';
import Search from './components/Search';
import HotCompany from './components/HotCompany';
// import HotCity from './components/HotCity'
import Cascader from './components/Cascader';
import notice from '@/views/company/vip/notice';
import $ from 'jquery';
export default {
  name: 'Home',
  components: {
    Search,
    HotJob,
    HotCompany,
    notice,
    // HotCity,
    Cascader
  },
  data() {
    return {
      minWidth: 0,
      gray: false,
      webUrl: window.global.BaseUrl,
      carousel: [],
      options: []
    };
  },
  created() {
    //国考考试活动弹窗
    //   this.$nextTick(() => {
    //     const _url = `https://mp.weixin.qq.com/s/Eq-IE1nGm5QNUwkeO8x4AQ`;
    //     const _content = `2024年国考面试公益讲座来了！<br/><br/>公考大咖 | 分享干货 <br/><br/>机会难得 | 不容错过<br/><br/>地址：1月28日  沃金大厦 <br/><br/> 抢席热线：15518896927、400-0372-889 `;
    //     const _start = '2024-01-25 00:00';
    //     const _end = '2024-01-28 12:00';
    //     this.$refs.noticeRef._open(_content, 'guokao', _start, _end, _url);
    //   });
  },
  mounted() {
    const that = this;
    this.$store.state.layoutId = '1'; //设置路由颜色
    this.minWidth = this.$store.state.bodyWidth;
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.$http.post(window.global.webUrl + 'v3_0/home/default.php', false).then((res) => {
        if (res.success === '1') {
          this.carousel = res.ad;
          this.$store.state.gray = res.filter == '1';
          if (this.$store.state.gray) {
            $('html').css({
              '-webkit-filter': 'grayscale(100%)',
              '-moz-filter': 'grayscale(100%)',
              '-ms-filter': 'grayscale(100%)',
              '-o-filter': 'grayscale(100%)',
              // ie滤镜
              filter: 'progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)',
              // ie6 等低版本浏览器不需要加滤镜
              _filter: 'none'
            });
          }
          localStorage.setItem('catejob', JSON.stringify(res.catejob)); //职位类别
          localStorage.setItem('diqu', JSON.stringify(res.diqu)); //地区
          localStorage.setItem('education', JSON.stringify(res.education)); //学历
          localStorage.setItem('expence', JSON.stringify(res.expence)); //经验
          localStorage.setItem('sex', JSON.stringify(res.sex));
          localStorage.setItem('nature', JSON.stringify(res.nature)); //企业性质
          localStorage.setItem('job_tag', JSON.stringify(res.job_tag)); //福利标签
          localStorage.setItem('wage', JSON.stringify(res.wage)); //薪资
          localStorage.setItem('resumetag', JSON.stringify(res.resumetag)); //形象标签
          localStorage.setItem('scale', JSON.stringify(res.scale)); //规模标签
          localStorage.setItem('trade', JSON.stringify(res.trade)); //行业
          this.$refs.hotJob.setData(res.job); //热门职位
          this.$refs.search.setData(res.job);
          this.$refs.hotCompany.setData(res.rscom); //热门企业
          this.options = res.catejob;
          // this.$refs.cascader.setData(res.catejob)
        }
      });
    },
    getData() {
      const _data = {
        method: 'list',
        page: 1
      };
      this.$http.post('/search_jobs_list', _data).then((res) => {
        if (res.success === '1') {
          this.$refs.hotJob.setData(res.list); //热门职位
          this.$refs.search.setData(res.list);
        }
      });
    },
    picClick(item) {
      if (item.id === '2238') {
        return;
      }
      if (item.id === '2247') {
        this.$router.push('/home/realDetail?id=7884');
      } else {
        if (item.img_id) {
          this.$router.push('/person/JobFairs?id=' + item.img_id);
        } else if (item.img_url) {
          window.open(item.img_url);
        } else {
          this.$router.push('/person/JobFairsList');
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import url('./home.css');
</style>
